import { render } from "./AttributeValue.vue?vue&type=template&id=02e3d8c0&scoped=true"
import script from "./AttributeValue.vue?vue&type=script&lang=js"
export * from "./AttributeValue.vue?vue&type=script&lang=js"

import "./AttributeValue.vue?vue&type=style&index=0&id=02e3d8c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e3d8c0"]])

export default __exports__